import Api from "./api";

class InitialMapStateApi {
  static getByInfoSet = (projectSchema, gisogdSection, infoSetKey) => {
    const url = infoSetKey
      ? `v1/initialMapState/${projectSchema}/${gisogdSection}?infoSetKey=${infoSetKey}`
      : `v1/initialMapState/${projectSchema}/${gisogdSection}`;

    return Api.get(url).then((response) => {
      return response.data;
    });
  };

  static getByIsogdDoc = (
    projectSchema,
    gisogdSection,
    docKey,
    onlyDocument
  ) => {
    const url = docKey
      ? `v1/initialMapState/${projectSchema}/${gisogdSection}?docKey=${docKey}` +
        (onlyDocument ? `&onlyDocument=${onlyDocument}` : ``)
      : `v1/initialMapState/${projectSchema}/${gisogdSection}`;

    return Api.get(url).then((response) => {
      return response.data;
    });
  };
}

export default InitialMapStateApi;
